var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown',{class:'language-dropdown',attrs:{"selected":_vm.selected,"options":_vm.options},on:{"optionSelected":_vm.changeLanguage}})
}
var staticRenderFns = []

export { render, staticRenderFns }